module.exports = __webpack_public_path__ + "img/cropped-Favicon_CrediTú-270x270.11a053b3.png";